import React from "react"
import PropTypes from "prop-types"

import LoaderSection from '../app_components/LoaderSection'
import SettingsTextInput from '../form_sections/SettingsTextInput'
import SettingsLongTextInput from '../form_sections/SettingsLongTextInput'
import DateInput from '../form_sections/DateInput'
import LocationSettings from './LocationSettings'
import GenderSection from './sections/GenderSection'
import NationalitySection from './sections/NationalitySection'
import ProfilePictureSection from './sections/ProfilePictureSection'
import PauseOrCancelAccount from './pause_account/PauseOrCancelAccount'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

class UserSettingsContainer extends React.Component {

    constructor(props) {
      super(props)

      this.state = {
        user: {},
        loaded: false,
        saveUserTimeout: null,
        savedAlert: null,
        saved: false,
        pauseAccountOpen: false
      }

      this.getUserData = this.getUserData.bind(this)
      this.updateUser = this.updateUser.bind(this)
      this.savedTimer = this.savedTimer.bind(this)
      this.saveUser = this.saveUser.bind(this)
      this.savedAlert = this.savedAlert.bind(this)
      this.updateBirthday = this.updateBirthday.bind(this)
      this.togglePauseContainer = this.togglePauseContainer.bind(this)
    }

    getUserData() {
      $.ajax({
        url: `../getUserData`,
        dataType: 'JSON',
        type: 'GET',
        header: {
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.setState({
            user: JSON.parse(data.data.current_user),
            loaded: true
          })
        },
        error: function(xhr, status, err) {
          console.log(err)
        }.bind(this)
      });
    }

    componentDidMount() {
      this.getUserData()
    }

    updateBirthday(date) {
      this.updateUser(date, 'birthday')
    }

    updateUser(value, attribute) {
      this.setState({
        user: {...this.state.user, [attribute]: value},
      }, () => {
        const { saveUserTimeout } = this.state;
        clearTimeout(saveUserTimeout);
        this.setState({
          saveUserTimeout: setTimeout(() => {
            this.saveUser()
          }, 300)
        })
      })
    }

    saveUser() {
      let data = {
        user: {
          first_name: this.state.user.first_name,
          last_name: this.state.user.last_name,
          nickname: this.state.user.nickname,
          email: this.state.user.email,
          bio: this.state.user.bio,
          gender_id: this.state.user.gender_id,
          bio: this.state.user.bio,
          birthday: this.state.user.birthday,
          nationality: this.state.user.nationality,
        }
      }
      $.ajax({
        url: `../updateUser`,
        dataType: 'JSON',
        type: 'POST',
        data: data,
        header: {
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.setState({
            saved: true
          }, () => this.savedTimer())
        },
        error: function(xhr, status, err) {
          console.log(err)
        }.bind(this)
      });
    }

    togglePauseContainer() {
      this.setState({
        pauseAccountOpen: !this.state.pauseAccountOpen
      })
    }

    savedTimer() {
      const { saveUserTimeout } = this.state;
      clearTimeout(saveUserTimeout);
      this.setState({
        saveUserTimeout: setTimeout(() => {
          this.setState({
            saved: false
          })
        }, 1000)
      })
    }

    componentWillUnmount() {
      const { saveUserTimeout } = this.state;
      clearTimeout(saveUserTimeout);
    }

    savedAlert() {
      return(
        <div style={{
          position: 'fixed',
          top: 100,
          backgroundColor: '#977DFF',
          width: 500,
          maxWidth: '95%',
          justifyContent: 'center',
          padding: 10,
          borderRadius: 10,
          display: 'flex',
        }}>
          <FontAwesomeIcon
            icon={faCheckCircle}
            style={{color: 'white', fontSize: 20, marginRight: 10}}
          />
          <h3 style={{color: 'white'}}>Profile updated!</h3>
        </div>
      )
    }

    render() {
      if(!this.state.loaded) {
        return <LoaderSection />
      }
      if(this.state.pauseAccountOpen) {
        return(
          <PauseOrCancelAccount
            togglePauseContainer={() => this.togglePauseContainer()}
          />
        )
      }
      return(
        <div style={{width: 500, maxWidth: '95%', padding: 10, margin: 'auto'}}>
            {this.state.saved && this.savedAlert()}
          <ProfilePictureSection user={this.state.user}/>
          <div className="greyDivider" />
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <SettingsTextInput
              label={'First Name'}
              attribute={'first_name'}
              value={this.state.user.first_name}
              onChange={this.updateUser}
              placeholder={'First Name'}
            />
            <SettingsTextInput
              label={'Preferred Name (optional)'}
              attribute={'nickname'}
              value={this.state.user.nickname}
              onChange={this.updateUser}
              placeholder={'Nickname'}
            />
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <SettingsTextInput
              label={'Last Name'}
              attribute={'last_name'}
              value={this.state.user.last_name}
              onChange={this.updateUser}
              placeholder={'Last Name'}
            />
            <SettingsTextInput
              label={'Email'}
              attribute={'email'}
              value={this.state.user.email}
              onChange={this.updateUser}
              placeholder={'Email'}
            />
          </div>
          <SettingsLongTextInput
            label={'A little about yourself...'}
            attribute={'bio'}
            value={this.state.user.bio}
            onChange={this.updateUser}
            placeholder={'Why are you learning a language? What do you like to do fo fun? Why are you awesome?'}
          />
          <div className="greyDivider" />
            <GenderSection
              user={this.state.user}
              updateUser={this.updateUser}
            />
            <NationalitySection
              user={this.state.user}
              updateUser={this.updateUser}
            />
            <DateInput
              onChange={this.updateBirthday}
              label="Birthday"
              value={new Date(this.state.user.birthday)}
              inputError=""
              maxDate={Date.now()-(3600*1000*24)}
              showYearDropdown={true}
              showMonthDropdown={true}
            />
          <div className="greyDivider" />
            <LocationSettings />

          <div className="form_section" style={{maxWidth: 450, margin: 'auto', marginTop: 50}}>
            <div className="greyDivider" />
            <div>
              <h3 className="red clickable" style={{textAlign: 'center', marginTop: 50}} onClick={() => this.togglePauseContainer()}>Pause or cancel account</h3>
            </div>
          </div>
        </div>
      )
    }
}

export default UserSettingsContainer
